import React from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

// Components imports
import InputField from "../common/InputField";
import Button from "../common/Button";

// Scss imports
import css from "./LoginForm.module.scss";

// redux
import { useDispatch } from "react-redux";
import { login } from "../../redux/actions/loginAction";

interface LoginFormProps {
  onClickButtonHandler: Function;
  handleChange: Function;
  email: string;
  password: string;
  errorEmailText: string;
  errorPasswordText: string;
  disabledButton: boolean;
  onInputPassword: any;
  onInputEmail: any;
}

const LoginForm: React.FC<LoginFormProps> = ({
  onClickButtonHandler,
  handleChange,
  email,
  password,
  errorEmailText,
  errorPasswordText,
  disabledButton,
  onInputPassword,
  onInputEmail
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <form className={css.container}>
      <div className={css.inputFieldWrapper}>
        <InputField
          label="Е пошта"
          name="email"
          id="email"
          type="email"
          placeholder="email@gmail.com"
          value={email}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "email@gmail.com")}
          errorText={errorEmailText}
          onInputHandler={onInputEmail}
        />
      </div>

      <div className={css.inputFieldWrapper}>
        <InputField
          label="Шифра"
          name="password"
          id="password"
          type="password"
          placeholder="Password12345"
          handleChange={handleChange}
          value={password}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "Password12345")}
          errorText={errorPasswordText}
          onInputHandler={onInputPassword}
        />
      </div>

      <div className={css.buttonHolder}>
        <Button
          disabledButton={disabledButton}
          text="Улогуј се"
          onButtonClickHandler={() =>
            dispatch(login({ email: email, password: password }, history))
          }
        />
        <div className={css.linksWrapper}>
          <Link to="/signup">
            <p>Немате налог, региструјте се</p>
          </Link>
          <Link to="/reset-password">
            <p>Заборављена шифра, ресетуј</p>
          </Link>
        </div>
      </div>
    </form>
  );
};

export default LoginForm;
